import React from 'react'
import PolicyPage from '~/components/shared/PolicyPage'

const ContactUsPage = () => <PolicyPage policyPage="contact-us" />

export default ContactUsPage
